module.exports = __webpack_public_path__ + "img/_ecp_.5c50f1f9.svg";